import { Permission } from "store/api/generatedApi";

export const ANALYTICS_PERMISSIONS: Permission[] = [
  "analytics_admin",
  "strategy_dashboard_inventory",
  "strategy_dashboard_consumption",
  "strategy_dashboard_production",
  "strategy_dashboard_quality",
  "strategy_dashboard_cost",
  "strategy_dashboard_prices",
  "strategy_dashboard_savings",
  "strategy_dashboard_schedule",
  "strategy_dashboard_heats",
  "strategy_dashboard_scrap_chef_usage",
  "strategy_dashboard_deliveries",
  "strategy_dashboard_compliance",
  "strategy_dashboard_consumption_projection",
  "strategy_dashboard_editing",
  "strategy_dashboard_crew_comparison",
];
